import type { EndpointResponse } from '@/services/api/endpointTypes';
import type { envApi } from '@/domain/env/api';
import type { companySettingsBankFeedRules } from '@/abilities/companySettings/rules/bankFeed';

export type CompanyBankFeedAccessValues = {
  readonly isAdmin: boolean;
  readonly bankFeedUserPermissions: EndpointResponse<typeof envApi.getCompanyUserPreferences>;
};

// Typed from the borrowed settings set, so a value that set starts to read fails here instead of reaching it undefined.
export type CompanyBankFeedAccessContext = Parameters<typeof companySettingsBankFeedRules>[0] & {
  readonly bankFeedTransactionViewGranted: boolean;
};

export const companyBankFeedAccessContext = ({
  isAdmin,
  bankFeedUserPermissions: { bank_feed_permissions: permissions },
}: CompanyBankFeedAccessValues): CompanyBankFeedAccessContext => ({
  isAdmin,
  bankFeedTransactionViewGranted: permissions.transaction_view,
  bankFeedConnectionViewGranted: permissions.connection_view,
});
